import React, { useEffect, useState } from "react";
import workerAnniversary from "../../../../assets/dashboard/worker.jpg";
import {
  baseURLImage,
  formatDateIntoDMYToDisplay,
  formatDateToAustralian,
  getNameProfile,
} from "Utils/utils";
import { Link } from "react-router-dom";
import { roleAccess } from "../../../../helpers/RolesPermission";
import {
  PERMISSION_KEYS,
  PERMISSION_KEYS_CHILDREN,
} from "../../../../store/constants";
import "../ExpiringDateTable/style.css";
const AnnualPerformanceCard = ({ item }) => {
  const [isDatePassed, setIsDatePassed] = useState(false);

  useEffect(() => {
    const reviewDate = new Date(item?.review_date);
    const today = new Date();
    setIsDatePassed(reviewDate < today);
  }, [item]);

  const backgroundImageStyle = {
    backgroundImage: `url(${workerAnniversary})`,
    backgroundSize: "cover", // Adjust as needed
    backgroundRepeat: "no-repeat", // Adjust as needed
  };

  //check date if date is today
  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() && date.getMonth() === today.getMonth()
    );
  };

  // Usage example:
  const reviewDate = new Date(item?.review_date);
  const isReviewToday = isToday(reviewDate);

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };

  const handleRedirection = (element) => {
    if (
      roleAccess(
        [],
        PERMISSION_KEYS.HRM,
        PERMISSION_KEYS_CHILDREN.HRM.WORKER.SHOW
      )
    ) {
      return `/worker-profile/${element?.uuid}`;
    }

    return "#";
  };

  return (
    <Link to={handleRedirection(item)}>
      <div className={`
        bg-gradient-to-br from-purple-50 via-indigo-50 to-purple-100 
        border rounded-lg p-3 sm:p-4 
        hover:shadow-md transition-all duration-200 group
        ${isDatePassed ? 'border-red-300 bg-red-50/50' : 'border-purple-200'}
      `}>
        <div className='flex items-center gap-2 sm:gap-3'>
          <div className='relative h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0'>
            <img
              onError={(e) => handleImageError(e, item?.name, item?.name)}
              className='object-cover h-10 w-10 sm:h-12 sm:w-12 rounded-full ring-2 ring-purple-300 group-hover:ring-purple-400 transition-all'
              src={
                item?.photo
                  ? baseURLImage(item?.photo)
                  : getNameProfile(item.name, item?.name || " ")
              }
              alt=''
            />
            {isReviewToday && (
              <div className="absolute -top-1 -right-1 h-3 w-3 sm:h-4 sm:w-4 bg-purple-500 rounded-full border-2 border-white animate-pulse"></div>
            )}
          </div>
          <div className='flex-1 min-w-0'>
            <div className='font-semibold text-xs sm:text-sm text-gray-900 capitalize truncate'>
              {item?.name}
            </div>
            <div className={`text-[10px] sm:text-xs font-medium mt-1 ${isDatePassed ? 'text-red-600' : isReviewToday ? 'text-purple-600' : 'text-gray-600'}`}>
              {isReviewToday ? (
                <span className="flex items-center gap-1">
                  <span className="inline-block w-1.5 h-1.5 sm:w-2 sm:h-2 bg-purple-500 rounded-full animate-pulse"></span>
                  <span className="truncate">Review Today</span>
                </span>
              ) : (
                <span className="truncate">
                  Review: {formatDateIntoDMYToDisplay(item?.review_date)}
                  {isDatePassed && <span className="ml-1 sm:ml-2 text-red-600 font-semibold">(Overdue)</span>}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default AnnualPerformanceCard;
